
const state = {

    modalShowing    : false,
    modalComponent  : null
};

const mutations = {

    toggleModal( state, component ){

        if( component ) state.modalComponent = component;
        state.modalShowing = !state.modalShowing;
    },
    backDropClicked( state ){

        if( state.modalShowing ) state.modalShowing = ! state.modalShowing;
    }
};

const actions = {

    toggleModal( { commit }, component = null ){

        commit( 'toggleModal', component );
        commit( 'toggleBackdrop', null, { root: true } );
    }
};

const getters = {

    modalShowing   : state => state.modalShowing,
    modalComponent : state => state.modalComponent
};

export default {

    namespaced: true,
    state,
    mutations,
    actions,
    getters
};